import { z } from 'zod'

export const formSchema = z.object({
  fullName: z.string().nonempty({
    message: 'Nama wajib diisi'
  }),
  companyName: z.optional(z.string()),
  whatsapp: z
    .string()
    .nonempty({ message: 'Nomor WhatsApp wajib diisi' })
    .min(10)
    .regex(/^(0)[0-9]{10,}$/),
  email: z.optional(z.string()),
  message: z.string().nonempty({ message: 'Pesan atau pertanyaan wajib diisi' })
})

export const defaultValues = {
  fullName: '',
  companyName: '',
  whatsapp: '',
  email: '',
  message: ''
}
